import React, { useEffect, useState } from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import {
  Group,
  LoadingOverlay,
  Text,
  TextInput,
  Textarea
} from '@mantine/core';
import Button from '../../components/elements/Button';
import { HiCheck, HiXMark } from 'react-icons/hi2';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '../../utilities/mantineNotification';
import { pickVoucher } from '../../services/transaksiRedeem';

const ModalConfirmationAction = ({ opened, onClose, onSubmit, type, data }) => {
  const clientQuery = useQueryClient();
  const [disabled, setDisabled] = useState(false);
  const [notesValue, setNotesValue] = useState('');

  const approvalRedeem = useMutation({
    mutationFn: pickVoucher,
    onSuccess: () => {
      clientQuery.refetchQueries({
        queryKey: ['getTransaksiRedeem']
      });
      setNotesValue('');
      onSubmit();
      showNotification({
        type: 'success',
        title: 'Success',
        message: 'Redeem request has been submitted'
      });
    },
    onError: (error) => {
      onSubmit();
      showNotification({
        type: 'error',
        title: 'Error when approval redeem',
        message: JSON.stringify(error)
      });
    }
  });

  useEffect(() => {
    if (type === 'reject' && notesValue === '') {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [type, notesValue]);

  const handleSubmitApproval = () => {
    const payload = {
      inventoryRewardID: data.inventoryRewardID,
      inventoryRewardPickedID: data.inventoryRewardPickedID,
      notes: notesValue,
      status: type === 'approve' ? 'Approved' : 'Rejected'
    };
    approvalRedeem.mutate(payload);
  };

  return (
    <>
      <ModalWrapper
        isVisible={opened}
        onClose={onClose}
        title={`${type === 'approve' ? 'Approve' : 'Reject'} Redeem Request`}
      >
        <Text className="text-md-regular">
          Are you sure you want to{' '}
          <Text span className="text-md-bold">
            {' '}
            {type}
          </Text>{' '}
          this redeem request?
        </Text>

        <Textarea
          label={`Notes ${type === 'approve' ? '(Optional)' : ''}`}
          placeholder="Type your notes here..."
          mt={16}
          withAsterisk={type === 'reject'}
          value={notesValue}
          onChange={(e) => setNotesValue(e.currentTarget.value)}
          rows={6}
        />

        <Group my={16} justify="flex-end">
          <Button
            variant="error-beelajar"
            onClick={() => {
              setNotesValue('');
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            leftSection={type === 'approve' ? <HiCheck /> : <HiXMark />}
            variant={type === 'approve' ? 'solid' : 'error'}
            disabled={disabled}
            onClick={handleSubmitApproval}
          >
            {type === 'approve' ? 'Approve' : 'Reject'}
          </Button>
        </Group>
        <LoadingOverlay visible={approvalRedeem.isLoading} />
      </ModalWrapper>
    </>
  );
};

export default ModalConfirmationAction;
